import { Link, useParams } from "react-router-dom";
import NavBar from "../components/NavBar";
import Loading from "../components/LoadingComponent";
import ErrorComponent from "../components/ErrorComponent";
import ScrollTopButton from "../components/ScrollTopButton";
import useFetchBookChapters from "../custom_hook/useFetchBookChapters";
import Footer from "../components/Footer";

const ChapterPage = () => {
  let { bookId } = useParams();

  const { chapters, book, error, loading } = useFetchBookChapters(bookId || "");

  if (loading) {
    return (
      <>
        <Loading />
      </>
    );
  }

  if (error) {
    return (
      <>
        <ErrorComponent message={error.message} />
      </>
    );
  }

  return (
    <>
      <nav className="navbar navbar-dark bg-dark">
        <NavBar />
      </nav>
      <div>
        <nav id="title-bar" className="navbar bg-dark">
          {book?.title}
        </nav>
      </div>
      <div className="container bg-dark">
        <nav id="bc-nav" aria-label="breadcrumb">
          <ol id="bc-ol" className="breadcrumb">
            <li className="breadcrumb-item">
              <Link className="inactive-anchor-link" to={"/"}>
                Books
              </Link>{" "}
              <span className="greater-than">&#x02AA2;</span>
            </li>
            <li id="bc-active" className="breadcrumb-item active">
              {book?.title}
            </li>
          </ol>
        </nav>
        <ul className="list-group bg-dark">
          {chapters.map((chapter) => (
            <Link
              className="anchor-link"
              to={`chapters/${chapter.id}`}
              key={chapter.id}
            >
              <li
                id="book-list-row"
                className="list-group-item bg-dark text-light d-flex justify-content-between"
              >
                <span>
                  ({chapter.number}) {chapter.title}
                </span>
                {chapter.completion_status === "Pending" ||
                chapter.completion_status === "Under Review" ? (
                  <span className="completion-status">
                    &#9203; {chapter.completion_status}
                  </span>
                ) : (
                  <span className="completion-status">
                    &#9989; {chapter.completion_status}
                  </span>
                )}
              </li>
            </Link>
          ))}
        </ul>
      </div>
      <ScrollTopButton />
      <Footer/>
    </>
  );
};

export default ChapterPage;
